export default "__VITE_ASSET__BqjWklqW__"